import {ChangeDetectorRef, OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {TranslationService} from '../services/translation.service';
import {AsyncPipe} from '@angular/common';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform, OnDestroy {

  private async: AsyncPipe;

  constructor(
    private translationService: TranslationService,
    changeDetectionRef: ChangeDetectorRef
  ) {
    this.async = new AsyncPipe(changeDetectionRef);
  }

  transform(value: any, args?: any): string {
    if (!value) {
      return '';
    }
    return this.async.transform(this.translationService.getWordByKey(value));
  }

  ngOnDestroy(): void {
    this.async.ngOnDestroy();
  }

}
